import axios from 'axios'
import { useAuthStore } from '@/stores/auth'

axios.defaults.withCredentials = false

const axiosInstance = axios.create()

axiosInstance.interceptors.request.use((config) => {
  const modifiedConfig = config

  const auth = useAuthStore()
  const apiKey = auth.apiKey

  if (apiKey && modifiedConfig.headers) {
    // Ensure we do not override an existing X-Api-Key header.
    if (!modifiedConfig.headers['X-Api-Key']) {
      modifiedConfig.headers['X-Api-Key'] = apiKey;
    }
  }

  return modifiedConfig
})

export default axiosInstance
